import { useQuery } from "@tanstack/react-query";
import { getVacancyApplications } from "../api/vacancyApi";
import { vacancyKeys } from "../api/vacancyKeys";

// Candidatos postulados.
export const useVacancyApplications = () =>
  useQuery({
    queryKey: vacancyKeys.applications(),
    queryFn: getVacancyApplications,
  });
